import { render, staticRenderFns } from "./TabPlans.vue?vue&type=template&id=127f3886"
import script from "./TabPlans.vue?vue&type=script&lang=js"
export * from "./TabPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports